import { CalendarMonthOutlined } from "@mui/icons-material"
import { data } from "@remix-run/router"
import { useTranslation } from "react-i18next"
import { fields } from "src/components/utils/fields"
import { M_Fieldset } from "src/M_Components"
import { QuoteFormField } from "./QuoteFormField"

export const QuoteRequestDates = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  const formFields = [
    {
      display: t("StartDate"),
      required: true,
      code: "startDate",
      type: "date",
    },
  ]

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <CalendarMonthOutlined
              style={{ marginRight: "10px", scale: "1.3" }}
            />{" "}
            {t("Dates")}
          </div>
        }
        elements={
          <div
            style={{
              display: "grid",
              justifyContent: "space-evenly",
            }}
          >
            {formFields.map((field, index) => <QuoteFormField fields={field} index={index} data={dataState} setData={setDataState} toggleable={dataState.isMultiEdit} />)}
          </div>
        }
      />
    </>
  )
}
